var React = require('react');

function Lines (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,.5H965","style":{"fill":"none","stroke":"#1d1d1b"}}));
}

Lines.defaultProps = {"id":"uuid-590bddc4-e469-468e-83f5-c70c88780961","viewBox":"0 0 965 1"};

module.exports = Lines;

Lines.default = Lines;
